import angular from 'angular';
import uiRouter from 'angular-ui-router';
import onTheBeachComponent from './onTheBeach.component';
import Login from './login/login';
import Booking from './booking/booking';
import otbNavbar from '../../common/otbNavbar/otbNavbar';

const onTheBeachModule = angular.module('onTheBeach', [
    uiRouter,
    otbNavbar,
    Login,
    Booking
])
.config(($stateProvider) => {
    "ngInject";
    $stateProvider
        .state('onTheBeach', {
            abstract: true, 
            url: '/{locale}/on-the-beach',
            resolve: {
                checkLocale: ($state, $stateParams, $location) => {
                    'ngInject';
                    if ($stateParams.locale !== 'en') {
                        const currentPath = $location.path();
                        const newPath = currentPath.replace(`/${$stateParams.locale}/`, '/en/');
                        $location.path(newPath).replace();
                        return false;
                    }
                    return true;
                }
            },
            views: {
                'navbar@': {
                    template: '<otb-navbar></otb-navbar>'
                },
                'main@': {
                    template: '<on-the-beach></on-the-beach>'
                },
                'footer@': {
                    template: '<footer></footer>'
                }
            }
        });
})
.component('onTheBeach', onTheBeachComponent)
.name;

export default onTheBeachModule;



// WEBPACK FOOTER //
// ./client/app/routes/onTheBeach/onTheBeach.js